import { graphql } from "gatsby";
import React from "react";
import PhotosRow from "../components/PhotosRow";

const PhotosRowParagraph = ({ content }) => {
  const row_description = content.row_description.value;
  const sections = content.r?.field_photo_row_section;

  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: row_description,
        }}
      ></div>
      <PhotosRow sections={sections} />
    </>
  );
};

export const query = graphql`
  fragment ParagraphPhotosRow on paragraph__photo_row {
    __typename
    id
    row_description: field_photo_row_description {
      value
    }
    r: relationships {
      field_photo_row_section {
        section_title: field_photo_section_title
        description: field_photo_section_description {
          processed
        }
        section_link: field_photo_section_link {
          title
          uri
        }
        r: relationships {
          image: field_photo_section_image {
            field_image {
              alt
            }
            r: relationships {
              field_image {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default PhotosRowParagraph;
